import Image, { ImageProps } from 'next/image';
export function getThemedImage(src: string, srcDark: string, alt: string, props: Omit<ImageProps, 'src' | 'alt'> = {}) {
  return <>
      <Image src={src} alt={alt} {...props} className={`block dark:hidden object-cover ${props.className || ''}`} data-sentry-element="Image" data-sentry-source-file="get-themed-image.tsx" />
      <Image src={srcDark} alt={alt} {...props} className={`hidden dark:block object-cover ${props.className || ''}`} data-sentry-element="Image" data-sentry-source-file="get-themed-image.tsx" />
    </>;
}